import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ISatelliteLocation } from 'app/models/licenses/satellite-location/satellite-location';

@Injectable({providedIn: 'root'})

export class SatelliteLocationService {
  private api: string = environment.privateApi + 'SatelliteLocation/';
  private http = inject(HttpClient);

  public GetSatelliteLocations(entityId: number, entityType: string, includeArchived: boolean): Observable<ISatelliteLocation[]>{
    return this.http.get<ISatelliteLocation[]>(this.api + 'GetSatelliteLocations/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  public createSatelliteLocation(satelliteLocation: ISatelliteLocation, entityId: number, entityType: string): Observable<ISatelliteLocation>{
    return this.http.post<ISatelliteLocation>(this.api + 'CreateSatelliteLocation/' + entityId + '/' + entityType, satelliteLocation);
  }

  public updateSatelliteLocation(satelliteLocation: ISatelliteLocation): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateSatelliteLocation', satelliteLocation);
  }

  public deleteSatelliteLocation(satelliteLocationId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteSatelliteLocation/' + satelliteLocationId);
  }
}
